import React from "react";
import { Button, ModalBody } from "reactstrap";
import { useAgent } from "../hooks/useAgent";
import styled from "styled-components";
import Drawer from "../../../Drawer";
import Contact from "../../../Contact";
import { useStickyVisibility } from "./hooks/useStickyVisibility";

/**
 * Agent sticky bar component.
 * @returns A responsive (on scroll) contact agent info bar.
 */
const AgentStickyBar = ({ headerRef }) => {
    const {
        agent_pic,
        agent_name,
        brokerageName,
        agent_website_phone,
        internalAgentID,
        isOpen,
        toggleIsOpen,
        handlePhoneClick,
    } = useAgent();
    const { isVisible } = useStickyVisibility({ headerRef });
    return (
        <>
            <StickyBar
                data-testid="agent-sticky-bar"
                className={`${!isVisible ? "hide" : ""}`}
                style={{ backgroundColor: "var(--bs-gray-100)" }}
            >
                <div className="d-flex container-lg agent">
                    <div className="me-3 my-2">
                        {agent_pic?.imageUrl && (
                            <img
                                style={{ maxHeight: "70px" }}
                                src={
                                    agent_pic?.imageUrl ||
                                    "/assets/no-image-found-360x260.png"
                                }
                                onError={(e) =>
                                    (e.target.src =
                                        "/no-image-found-360x260.png")
                                }
                                alt={agent_name?.value || "Agent"}
                                data-test="agent-photo"
                            />
                        )}
                    </div>
                    <div className="flex-column my-auto">
                        <div>{agent_name?.value}</div>
                        <div>{brokerageName?.value}</div>
                        <div>
                            {agent_website_phone?.value && (
                                <div data-test="agent-phone-bar">
                                    <Button
                                        color="link"
                                        className="m-0 p-0"
                                        href={`tel:${agent_website_phone?.value}`}
                                        onClick={() => handlePhoneClick()}
                                    >
                                        {agent_website_phone?.value}
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="ms-auto my-auto">
                        <Button
                            color="primary"
                            className="fw-medium btn-lg"
                            onClick={() => toggleIsOpen()}
                        >
                            Contact
                        </Button>
                    </div>
                </div>
            </StickyBar>

            <Drawer isOpen={isOpen} toggle={() => toggleIsOpen()}>
                <ModalBody data-testid="agent-contact-drawer">
                    <Contact agentId={internalAgentID} />
                </ModalBody>
            </Drawer>
        </>
    );
};

const StickyBar = styled.div`
    .agent {
        z-index: 1001;
    }
    @media (max-width: 768px) {
        margin-left: -0.25rem;
    }
    @media (max-width: 992px) {
        bottom: 0;
        border-top: var(--bs-border-width) var(--bs-border-style)
            var(--bs-border-color);
        &.hide {
            bottom: -100px;
        }
    }
    @media (min-width: 993px) {
        top: 0;
        border-bottom: var(--bs-border-width) var(--bs-border-style)
            var(--bs-border-color);
        &.hide {
            top: -100px;
        }
    }
    position: fixed;
    width: 100vw;
    margin-left: -1rem;
    z-index: 1001;
    transition: all 0.5s ease-out;
    background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity));
`;

export default AgentStickyBar;
